import {forward} from 'effector';

import {RestError, showRestError} from 'core/errors';
import {history} from 'core/history';

import {ROUTE} from 'core/routes';

import {
    CreateDocumentsReturnsGate,
    DocumentsReturnsGate,
    fetchReturnGoodsDictionaryFx,
    fetchStoragesFx,
    returnGoodsDictionary$,
    step$,
    stepChanged,
    storages$,
    submitDocumentReturnGoodsFx,
} from '.';

step$.on(stepChanged, (_, step) => step).reset(DocumentsReturnsGate.close);

forward({
    from: DocumentsReturnsGate.open,
    to: fetchStoragesFx,
});

forward({
    from: CreateDocumentsReturnsGate.open,
    to: fetchReturnGoodsDictionaryFx,
});

storages$
    .on(fetchStoragesFx.doneData, (_, {storageLocations}) => storageLocations)
    .reset(DocumentsReturnsGate.close);

returnGoodsDictionary$
    .on(fetchReturnGoodsDictionaryFx.doneData, (_, dictionary) => dictionary)
    .reset(CreateDocumentsReturnsGate.close);

fetchReturnGoodsDictionaryFx.fail.watch(({error}) => showRestError(error as RestError));
submitDocumentReturnGoodsFx.fail.watch(({error}) => showRestError(error as RestError));
submitDocumentReturnGoodsFx.done.watch(() => {
    history.push(ROUTE.DOCUMENTS_DOCUMENTS);
});
